import { VideoPlaylistTheme } from '@/components/VideoPlaylist/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const VideoPlaylist = GenericSlot({ as: 'div', theme: VideoPlaylistTheme });
